<section #mobileSidenav class="sidenav" [ngClass]="{ 'sidenav-hidden': !isOpened }">
  <app-generic-header-topline [user]="user$ | async" [isSidenavVersion]="true"></app-generic-header-topline>
  <app-mobile-parent-categories-navigation [isMenuOpened]="isOpened" [user]="user$ | async"></app-mobile-parent-categories-navigation>
</section>
<section #overlay class="overlay" [@fadeInOut]="isOpened ? 'visible' : 'hidden'">
  <div class="overlay__close" (click)="closeSidenav()">
    <button type="button">
      <mm-icon class="icon" name="close"></mm-icon>
    </button>
  </div>
</section>
